export default function currencyFormatted(amount) {
    // The data
    const price = {
        currency: 'UZS',
        amount: amount
    };

    // toLocaleString options
    const options = {
        style: 'currency',
        currency: price.currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    // £4.99
    return price.amount.toLocaleString(amount, options);
}

export function currencyNoSymbolFormatter(amount) {
    const options = {
        style: 'decimal',
        minimumFractionDigits: 0,  // 2
        maximumFractionDigits: 0,  // 2
    };

    return amount.toLocaleString('en-US', options);
}

export function currencyNoSymbolWithSpaceFormatter(amount) {
    /**
     Formats a number using European-style formatting:
     - Space as thousands separator (e.g., "12 000")
     - Comma as decimal separator (e.g., "12 000,23")
     - Always keeps two decimal places

     Example:
     currencyNoSymbolFormatter(12000.23); // "12 000,23"
     **/
    const options = {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    };

    return amount.toLocaleString('fr-FR', options);
}


export function transactionStatusToColorFormatter(status) {
    const statusColorMap = {
        FISCALIZED: 'green',
        PAID: 'blue',
        SUCCESS: 'blue',
        PROCESSING: 'default'
    };
    return statusColorMap[status] || 'red';
}
